<div>
  <div class="d-flex flex-row justify-content-between align-items-center mb-3 pt-1">
    <p class="m-0 pr-3">Create up to {{ appVariables.MAX_SAVED_REPLIES }} saved messages to quickly send standard replies to your {{ customerPluralLabel }} from the chat window. ({{ remainingReplies }} remaining)</p>

    <div [ngbTooltip]="repliesCount === appVariables.MAX_SAVED_REPLIES ? 'You’ve reached the limit of replies' : null" class="pr-3" placement="left">
      <button
        [disabled]="repliesCount === appVariables.MAX_SAVED_REPLIES"
        class="btn btn-info"
        (click)="addReply()"
        [style.min-width.px]="100"
      >&#43; Add reply</button>
    </div>
  </div>
  <div *ngIf="(replies$ | async) as replies" class="table-wrapper overflow-auto" [class.pr-3]="!isMobile">
    <table class="table tr-table table-bottom-spacer" [class.mr-3]="isMobile" [style.min-width]="'500px'">
      <thead>
      <tr>
        <th class="w-25">Reply name</th>
        <th class="w-100">Reply text</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody *ngIf="replies.length && isOnBusinessPlan; else noReplies">
      <tr *ngFor="let reply of replies; trackBy: trackById">
        <td [innerText]="reply.name"></td>
        <td [innerText]="reply.text" class="reply-body"></td>
        <td>
          <div class="d-flex flex-column align-content-between">
            <div class="d-flex flex-row justify-content-between w-100">
              <button class="btn btn-icon btn-info mr-2" (click)="editReply(reply.id)">
                <tr-icon [icon]="icon.edit" [color]="iconColor.white"></tr-icon>
              </button>

              <button
                class="btn btn-outline-danger btn-remove"
                (click)="deleteReply(reply.id)"
              >
                Delete
              </button>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #noReplies>
  <tr><td colspan="3"><h2 class="text-center">No replies found</h2></td></tr>
</ng-template>
